module.exports = __webpack_public_path__ + "static/media/vampire2.d282dc07.png";